import { Component, Input } from '@angular/core';
import { User } from '../../models/user';
import { UsersService } from '../../services/users.service';

@Component({
    selector: 'user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    standalone: false
})
export class UserAvatarComponent {
    @Input() user: User;
    @Input() size: 'large' | 'xlarge' | 'normal' = 'normal';

    imageFailed = false;

    private static readonly sizeMap: Record<string, string> = {
        normal: '24px',
        large: '36px',
        xlarge: '48px'
    };

    constructor(private usersService: UsersService) {}

    get sizeStyle(): string {
        return UserAvatarComponent.sizeMap[this.size] ?? UserAvatarComponent.sizeMap.normal;
    }

    get avatarUrl(): string {
        return this.usersService.GetAvatarUrl(this.user?.email);
    }

    get initials(): string {
        const parts = (this.user?.displayName ?? '').trim().split(' ').filter(Boolean);

        return parts.map(p => p[0])
            .slice(0, 2)
            .join('')
            .toUpperCase();
    }

    onImageError(): void {
        this.imageFailed = true;
    }
}
